---
title: About Part-time Instructor
cover_image: /images/article/priscilla-du-preez-Q7wGvnbuwj0-unsplash.jpg
description: "大学の非常勤講師や、高校の実習教科指導のこと"
---

大学の非常勤講師や、高校の実習教科指導のこと

### 工業系大学の情報科非常勤講師

> 経験: 2013年度より現在に至るまで

工業系大学の情報科で非常勤講師を務めさせてもらっています。

科目は演習専門で、以下の通りです。

1. プログラミング演習
    - Java, Python, Ruby, JavaScript等
    - オブジェクト指向プログラミングの講義での使用言語は主にJava,Pythonです。
2. Webデザイン演習
    - HTML, CSS, JavaScriptを用いたWebサイト構築の一連の流れを実習形式で行っています。
3. コンピュータネットワーク演習
    - Cisco CCNAの受験を目指す範囲での講義・実習指導ができます。（Cisco TTT資格所有）


### 高校の実習教科指導

> 経験: 2012年度より2022年度まで

高校教員免許（工業）を取得していたため、流れで情報科の情報実習の教科指導員を務めさせてもらっていました。



<br>
<br>
<br>

----
<small><span>Cover Photo by <a href="https://unsplash.com/@priscilladupreez?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Priscilla Du Preez</a> on <a href="https://unsplash.com/s/photos/teach?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Unsplash</a></span></small>